export enum DeterminantType {
    BOT = "BOT" as any,
    QUESTION = "QUESTION" as any,
    SERVICE = "SERVICE" as any,
    REGISTRATION = "REGISTRATION" as any,
    FORMFIELD = "FORMFIELD" as any,
    COLLECTION_PLACE = "COLLECTION_PLACE" as any,
}
